import React from "react";
import { useLang } from "../i18n/LangContext";

const Track = ({ items }) => (
  <ul className="flex items-center gap-16 pr-16 shrink-0" aria-hidden="true">
    {items.map((it, i) => (
      <li key={i} className="flex items-center gap-16 shrink-0">
        <span className="font-display text-xl sm:text-2xl lg:text-3xl font-semibold text-zinc-200/80 whitespace-nowrap">
          {it}
        </span>
        <span className="text-primary-red text-2xl">✦</span>
      </li>
    ))}
  </ul>
);

export const Marquee = () => {
  const { t, lang } = useLang();
  const items = t("marquee");

  return (
    <div
      data-testid="section-marquee"
      className="relative border-y border-white/5 bg-black/60 overflow-hidden py-6"
    >
      <div
        key={lang}
        className="animate-marquee flex w-max will-change-transform"
      >
        <Track items={items} />
        <Track items={items} />
      </div>
    </div>
  );
};
